import { render, staticRenderFns } from "./AddQuestionModal.vue?vue&type=template&id=59811654"
import script from "./AddQuestionModal.vue?vue&type=script&lang=js"
export * from "./AddQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports